import React from 'react'
import Notice from './notice'

export default function NoticeList({list}) {
    return <div className="notice-list">
            {list.map((notice) => {
                return <Notice key={notice.id} notice={notice} />
            })}
        </div>
}